import { useSafariPackagesContext } from 'provider/SharePackagesProvider';
import React from 'react'

const Disclaimer = () => {
  const { packageViewData } = useSafariPackagesContext();
  const businessName = packageViewData?.partner?.business_name;
  return (
    <div className='desclaimers pb-3'>
        <div className='itenary-title'>
            <h6 className='fs-5 pb-2'>Disclaimer</h6>
        </div>
        <div className='itenary-text'>
            <ul>
                <li>This tour is operated by <strong>{businessName}</strong> and not by Walk Into The Wild.</li>
                <li><strong>{businessName}</strong> reserves the right to adjust the rates advertised by Walk Into The Wild.</li>
                <li>The specific itinerary, inclusions, and pricing of this tour are dependent on availability.</li>
                <li>In the event that accommodations are fully booked, <strong>{businessName}</strong>  will propose a suitable alternative.</li>
                <li>This tour is governed by the terms and conditions set forth by Walk Into The Wild.</li>
            </ul>
        </div>
    </div>
  )
}

export default Disclaimer